module.exports = __webpack_public_path__ + "static/media/透明底反黑图-2.ed09456c.png";